import zh from './zh';

const zhHant = {
  ...zh,
  login: {
    ...zh.login,
    subtitle: '登入以繼續',
    email: '電郵',
    loginName: '登入名稱',
    password: '密碼',
    submit: '登入',
    submitting: '登入中…',
    failed: '登入失敗',
    heroTitle: '智能企業營運系統',
    heroDesc: '自動化營運、追蹤預訂，並在一個平台中管理您的整個營運工作流程。',
    forgotPassword: '忘記密碼？',
    securityNote: '您的連線已加密並安全。',
    back: '返回',
    selectTenant: '選擇工作區',
    brandingLoading: '租戶品牌資訊仍在載入，請稍後再試。',
    secureAccessFor: '{{company}} 專屬登入入口',
    workspaceOnHost: '{{portal}} · {{host}}',
    tenantWorkspace: '租戶工作區',
    shortAccountHint: '此處支援短帳號登入，例如 {{hint}}',
    dedicatedLogin: '這是 {{company}} 的專屬登入入口。',
    unauthorizedTenant: '您無權存取此應用程式。',
    noTenantAccess: '您的帳號沒有可存取的租戶。',
    invalidCredentials: '帳號或密碼錯誤。',
    bridgeFailed: '登入接續失敗',
  },
  dashboard: {
    ...zh.dashboard,
    title: '儀表板',
    welcome: '歡迎回來，{{name}}',
    goodMorning: '早安',
    goodAfternoon: '下午好',
    goodEvening: '晚上好',
    fields: '欄位',
    children: '子項',
    relations: '關聯',
  },
  category: {
    ...zh.category,
    home: '首頁',
    builder: '業務構建器',
    inbox: '收件箱',
    business: '商務',
    transport: '經典運輸',
    freight: '貨運領航',
    warehouse: '倉儲流',
    finance: '財務',
    workforce: '人力',
    settings: '設定',
    platform: '平台',
    accounting: '會計',
    service: '服務管理',
    'supply-chain': '供應鏈導航',
    haulage: '貨櫃拖車指揮台',
    depot: '堆場控制台',
  },
  group: {
    ...zh.group,
    Dashboards: '儀表板',
    Messages: '訊息',
    Tasks: '任務',
    Purchase: '採購',
    People: '人員',
    Branches: '分支機構',
    Access: '權限',
    Setup: '設定',
    Reports: '報表',
    Monitor: '監控',
    AR: '應收帳款',
    AP: '應付帳款',
    GL: '總帳',
    transactions: '交易',
    banking: '銀行',
    einvoicing: '電子發票',
    tax: '稅務',
    email: '郵件',
    dashboard: '儀表板',
    orders: '訂單',
    operations: '操作',
    import: '進口',
    export: '出口',
    master: '主數據',
    Import: '進口',
    Export: '出口',
    Master: '主數據',
    overview: '概覽',
    planning: '計劃',
    tools: '工具',
    admin: '管理',
    'self-service': '自助服務',
    Driver: '司機',
  },
  nav: {
    ...zh.nav,
    chat: 'AI 對話',
    Dashboard: '儀表板',
    Shipments: '貨件',
    Shipment: '貨件',
    Containers: '貨櫃',
    Container: '貨櫃',
    Cargo: '貨物',
    Costing: '成本',
    Billing: '計費',
    Rates: '費率',
    Documents: '文件',
    Import: '進口',
    Export: '出口',
    Transhipment: '轉運',
    'Cross Trade': '三角貿易',
    Local: '本地',
    Consol: '拼箱',
    Air: '空運',
    'Shipment Report': '貨件報表',
    'Billing Report': '計費報表',
    'Imp Shipment': '進口貨件',
    'Imp Container': '進口貨櫃',
    'Imp Cargo': '進口貨物',
    'Exp Shipment': '出口貨件',
    'Exp Booking': '出口訂艙',
    'Exp Container': '出口貨櫃',
    'Exp Cargo': '出口貨物',
    'Inv / Cost Note': '發票 / 成本單',
    'Charge Lines': '費用行',
    Invoices: '發票',
    Receipts: '收據',
    'AR Aging': '應收帳齡',
    'Vendor Bills': '供應商帳單',
    Payments: '付款',
    'Journal Entries': '記帳憑證',
    'P&L Reports': '損益報表',
    'Balance Sheets': '資產負債表',
    'Bank Account': '銀行帳戶',
    'Bank Accounts': '銀行帳戶',
    Statement: '結單',
    'Bank Statements': '銀行結單',
    Reconciliation: '對賬',
    'Chart of Accounts': '會計科目表',
    'Charge Code': '費用代碼',
    'Charge Codes': '費用代碼',
    'Tax Jurisdiction': '稅務司法區',
    'Tax Jurisdictions': '稅務司法區',
    'Tax Code': '稅碼',
    'Tax Codes': '稅碼',
    'Tax Rule': '稅務規則',
    'Tax Rules': '稅務規則',
    'Quotation / Rates': '報價 / 費率',
    'Job Order': '工作單',
    'Job Orders': '工作單',
    'By Customer': '按客戶',
    'By Date': '按日期',
    'Driver Log': '司機日誌',
    'Driver Pay': '司機薪酬',
    Team: '團隊',
    'My Trips': '我的行程',
    'My Pay': '我的薪酬',
    Driver: '司機',
  },
  today: {
    ...zh.today,
    title: '今日',
    tasks: '任務',
    allClear: '今日無待辦！',
    allClearDesc: '今天沒有需要處理的任務、作業或配送。',
    tripTitle: '行程 {{id}}',
    wmsTaskTitle: '倉儲 {{type}} #{{id}}',
  },
  module: {
    ...zh.module,
    hms: '貨櫃拖車指揮台',
    tms: '經典運輸',
    wms: '倉儲流',
    fms: '貨運領航',
    scm: '供應鏈導航',
    svc: '服務',
    hrm: '人力資源',
    oms: '訂單',
    acc: '財務',
  },
  svc: {
    ...zh.svc,
    status: {
      DRAFT: '草稿', CONFIRMED: '已確認', SCHEDULED: '已排期', DISPATCHED: '已派工',
      IN_PROGRESS: '進行中', COMPLETED: '已完成', INVOICED: '已開票', CANCELLED: '已取消',
      AVAILABLE: '可用', IN_USE: '使用中', MAINTENANCE: '維修中', RETIRED: '已停用',
      ON_DUTY: '在崗', OFF_DUTY: '離崗', ON_LEAVE: '請假', ACTIVE: '活躍', INACTIVE: '停用',
    },
    serviceType: {
      crane_lift: '吊裝作業', rigging: '索具作業', transport: '運輸', installation: '安裝',
      maintenance: '維護保養', inspection: '檢查', other: '其他',
    },
    priority: { low: '低', normal: '普通', high: '高', urgent: '緊急' },
    equipmentType: {
      crane: '起重機', forklift: '叉車', truck: '貨車', generator: '發電機',
      scaffold: '鷹架', tool_set: '工具套裝', other: '其他',
    },
    field: {
      customer: '客戶', site: '工地', serviceType: '服務類型', priority: '優先順序',
      scheduledDate: '預定日期', estHours: '預計工時', description: '描述', remarks: '備註',
      assetCode: '資產編號', name: '名稱', type: '類型', capacity: '容量/噸位', serialNo: '序號',
      location: '位置', nextServiceDate: '下次維保日期', code: '編號', crewName: '班組名稱',
      teamLeader: '組長', skills: '技能', siteCode: '工地編號', siteName: '工地名稱',
      contact: '聯絡人', phone: '電話', postalCode: '郵遞區號', address: '地址',
    },
    kpi: { totalOrders: '工單總數', scheduled: '已排期', inProgress: '進行中', completed: '已完成' },
    tab: {
      recentOrders: '最近工單', activeDispatched: '活躍 / 已派工', allOrders: '全部工單',
      draft: '草稿', active: '活躍', pendingDispatch: '待派工', dispatched: '已派工',
      allEquipment: '全部設備', available: '可用', maintenance: '維修中',
      allCrews: '全部班組', allSites: '全部工地', allInvoices: '全部帳單',
      pendingBilling: '待開票', costBreakdown: '成本明細', summary: '彙總',
    },
    col: {
      orderNo: '工單號', customer: '客戶', site: '工地', type: '類型', scheduled: '排期',
      status: '狀態', crew: '班組', date: '日期', equipment: '設備', priority: '優先順序',
      estHrs: '預計工時', created: '建立時間', assetCode: '資產編號', name: '名稱', capacity: '容量',
      location: '位置', nextService: '下次維保', lastService: '上次維保', code: '編號',
      crewName: '班組名稱', teamLeader: '組長', members: '成員', skills: '技能',
      siteName: '工地名稱', address: '地址', contact: '聯絡人', hours: '工時',
      materials: '材料費', total: '合計', labor: '人工費', totalCost: '總成本',
      revenue: '收入', marginPct: '毛利率', period: '統計週期', orders: '工單數',
      completed: '已完成', cost: '成本', avgHrsJob: '平均工時/單', serialNo: '序號',
      phone: '電話', postalCode: '郵遞區號',
    },
    action: {
      confirm: '確認', schedule: '排期', dispatch: '派工', startWork: '開始作業',
      complete: '完成', invoice: '開票', cancel: '取消',
      cancelConfirm: '確定取消此服務工單？',
    },
    page: {
      dashboard: '服務管理', orders: '服務工單', dispatch: '派工管理',
      equipment: '設備管理', crew: '班組管理', sites: '工地管理', billing: '服務帳單',
      costing: '服務成本', reports: '服務報表',
    },
    dialog: {
      newOrder: '新建服務工單', addEquipment: '新增設備', addCrew: '新增班組', addSite: '新增工地',
    },
  },
  common: {
    ...zh.common,
    loading: '載入中...',
    viewAll: '檢視全部',
    more: '更多',
    save: '儲存',
    reset: '重設',
  },
  settings: {
    ...zh.settings,
    desc: '自訂您的 Boox 使用體驗。',
    tabs: '分頁',
    clearTabsOnSignout: '登出時清除分頁',
    clearTabsOnSignoutDesc: '開啟後，登出時將關閉所有分頁。關閉可保留分頁到下次登入。',
    clearTabsEnabled: '登出時將清除分頁',
    clearTabsDisabled: '分頁將跨工作階段保留',
    voiceCommands: '語音指令',
    voiceCommandsAlwaysOn: 'PWA 常駐語音指令',
    voiceCommandsAlwaysOnDesc: '在 PWA 側邊欄新增麥克風開關，執行指令後繼續監聽，直到手動關閉。',
    voiceCommandsEnabled: 'PWA 語音指令已啟用',
    voiceCommandsDisabled: 'PWA 語音指令已停用',
  },
  accent: {
    ...zh.accent,
    label: '主題色',
  },
  sidebar: {
    ...zh.sidebar,
    collapse: '收合',
    expand: '展開',
  },
  mdi: {
    ...zh.mdi,
    closeTab: '關閉分頁',
    closeOther: '關閉其他分頁',
  },
  theme: {
    ...zh.theme,
    label: '主題',
    languageLabel: '語言',
    light: '淺色',
    dark: '深色',
    system: '跟隨系統',
  },
  chat: {
    ...zh.chat,
    searchPlaceholder: '搜尋…',
    newChat: '新對話',
    noSessions: '暫無對話\n點擊 + 開始',
    noSearchResults: '沒有匹配的對話',
    archive: '歸檔',
    delete: '刪除',
    archivedCount: '已歸檔 ({{count}})',
    restore: '恢復',
    managePrompts: '管理快捷提示',
    promptLabel: '簡稱（如 📋 今日摘要）',
    promptContent: '要問 AI 的完整問題…',
    autoExecute: '點擊後立即發送',
    noPrompts: '暫無快捷提示。點擊「新增」建立一個。',
    confirmDelete: '確定要刪除「{{label}}」嗎？',
    deleteFailed: '刪除對話失敗',
    archived: '對話已歸檔',
    restored: '對話已恢復',
    chatTitle: '對話',
    thinking: '思考中…',
    share: '分享對話',
    typeToStart: '在下方輸入以開始對話',
    startTyping: '說點什麼開始吧…',
    quickPrompts: '快捷提示',
    inputPlaceholder: '隨便問… (Enter 發送, Shift+Enter 換行)',
    stopRecording: '點擊停止',
    voiceInput: '點擊說話',
    stop: '停止產生',
    disclaimer: 'AI 回覆可能不準確，請務必核實關鍵資訊。',
    shareTitle: '分享對話',
    selectMessages: '選擇訊息',
    shareExpiry: '連結過期時間',
    generateLink: '產生分享連結',
    copied: '已複製！',
    copy: '複製',
    sharedConversation: '分享的對話',
    shareWhatsApp: '透過 WhatsApp 分享',
    shareInfo: '任何人都可以透過此連結查看對話，無需登入。',
    expiresAt: '過期時間',
  },

  finance: {
    ...zh.finance,
    method: {
      bank_transfer: '銀行轉帳',
      cheque: '支票',
      cash: '現金',
      paynow: 'PayNow',
      fps: 'FPS',
      other: '其他',
    },
    col: {
      document: '單據',
      method: '方式',
      date: '日期',
      amount: '金額',
      unallocated: '未分配',
      allocated: '已分配',
      status: '狀態',
    },
    kpi: {
      documents: '單據數',
      unallocatedExposure: '未分配敞口',
    },
    controls: {
      title: '結算控制',
      committedCash: '已確認現金流',
      allocationOpen: '分配仍在進行',
      unallocatedAmount: '未分配金額',
      requiresApproval: '需要審批',
      none: '無',
      yes: '是',
      no: '否',
    },
    action: {
      assist: '輔助',
      refresh: '重新整理',
      void: '作廢',
      reverse: '沖銷',
      apply: '沖抵',
    },
    dock: {
      header: '{{title}} 抬頭',
      appliedAllocations: '已分配明細',
      noAllocations: '暫無分配記錄。',
      lineBreakdown: '收付款行明細',
      noLines: '暫無行明細。',
      outstandingDocs: '未結對應單據',
      noOutstanding: '未找到該客戶/供應商的{{type}}未結單據。',
      outstandingAmt: '未結金額',
      noDueDate: '無到期日',
    },
    toast: {
      allocationApplied: '分配成功',
      allocationReversed: '沖銷成功',
      noUnallocated: '無可分配餘額',
      loadFailed: '載入{{entity}}失敗',
      allocationFailed: '分配失敗',
      reverseFailed: '沖銷失敗',
      voidConfirm: '確認作廢此{{kind}}？已有分配將被沖銷。',
      voided: '{{title}}已作廢',
      voidFailed: '作廢{{entity}}失敗',
    },
    empty: {
      selectRecord: '選擇一條記錄以檢查分配狀態和對應未結單據。',
    },
  },
} as const;

export default zhHant;
